import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// get All Parkings
export const getAllParkings = createAsyncThunk(
  "parking/getAllParkings",
  async (_, { rejectWithValue }) => {
    try {
      const result = await axios.get(`/getAllParking`, {
        withCredentials: true,
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getParkings = createAsyncThunk(
  "parking/getParkings",
  async (_, { rejectWithValue }) => {
    try {
      const result = await axios.get(`/get-parkings-names`, {
        withCredentials: true,
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get all user's parkings
// export const getParkingServices = createAsyncThunk(
//   "parking/getParkingServices",
//   async (parkingId: String, { rejectWithValue }) => {
//     try {
//       const result = await axios.get(`/get-services-parkingId/${parkingId}`, {
//         withCredentials: true,
//       });
//       return result.data;
//     } catch (error: any) {
//       return rejectWithValue(error.response.data);
//     }
//   }
// );

// get parking by id
export const getParkingId = createAsyncThunk(
  "parking/getParkingId",
  async (parkingId: String | null, { rejectWithValue }) => {
    try {
      const result = await axios.get(`/get-parking-id/${parkingId}`, {
        withCredentials: true,
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getParkingIdServices = createAsyncThunk(
  "parking/getParkingIdServices",
  async (parkingId: String | null, { rejectWithValue }) => {
    try {
      const result = await axios.get(`/get-parking-id/${parkingId}/services`, {
        withCredentials: true,
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getParkingIdSusbcriptions = createAsyncThunk(
  "parking/getParkingIdSusbcriptions",
  async (parkingId: String | null, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `/get-parking-id/${parkingId}/subscriptions`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getParkingIdLDReservations = createAsyncThunk(
  "parking/getParkingIdLDReservations",
  async (parkingId: String | null, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `/get-parking-id/${parkingId}/ldReservations`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);
export const getParkingIdProximityParkings = createAsyncThunk(
  "parking/getParkingIdProximityParkings",
  async ({ parkingId, siteId }: any | null, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `/get-parking-id/${parkingId}/proximityParkings`,
        {
          withCredentials: true,
          params: {
            siteId: siteId,
          },
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

// get the parking of the key accounts
export const getPartnerParkings = createAsyncThunk(
  "parking/get-partner-parkings",
  async (_, { rejectWithValue }) => {
    try {
      const result = await axios.get(`/get-partner-parkings`, {
        withCredentials: true,
      });
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getParkingSubscriptions = createAsyncThunk(
  "parking/get-parking-subscriptions",
  async (parkingId: String | null, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `/get-parking-subscriptions/${parkingId}`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

export const getParkingIdSusbcriptionsOrdered = createAsyncThunk(
  "parking/getParkingIdSusbcriptionsOrdered",
  async (parkingId: String | null, { rejectWithValue }) => {
    try {
      const result = await axios.get(
        `/get-parking-id/${parkingId}/subscriptionsOrdered`,
        {
          withCredentials: true,
        },
      );
      return result.data;
    } catch (error: any) {
      return rejectWithValue(error.response.data);
    }
  },
);

const parkingSlice = createSlice({
  name: "parking",
  initialState: {
    parking: {},
    parkings: [],
    subscriptionsParking: [],
    ldResParking: [],
    services: [],
    loading: false,
    description: null,
    errors: null,
    success: false,
    prepaidSubs: [],
    temporarySubs: [],
    parkingSubscriptions: [],
    proximityParkings: {},
    successService: false,
    loadingSub: false,
    loadingLDRes: false,
  },
  reducers: {
    clearErrors: (state) => {
      state.errors = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // get all parkings
      .addCase(getAllParkings.pending, (state) => {
        state.parkings = [];
        state.loading = true;
        state.errors = null;
      })
      .addCase(getAllParkings.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.parkings = action.payload.data;
      })
      .addCase(getAllParkings.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
        state.parkings = [];
      })
      // get all parkings
      .addCase(getParkings.pending, (state) => {
        state.parkings = [];
        state.loading = true;
        state.errors = null;
      })
      .addCase(getParkings.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.parkings = action.payload.Parkings;
      })
      .addCase(getParkings.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
        state.parkings = [];
      })

      // get parking by id
      .addCase(getParkingId.pending, (state) => {
        state.parking = {};
        state.loading = true;
        state.errors = null;
        state.services = [];
        state.prepaidSubs = [];
        state.temporarySubs = [];
        state.ldResParking = [];
        state.proximityParkings = {};
      })
      .addCase(getParkingId.fulfilled, (state, action) => {
        state.parking = action.payload.Parking;
        state.loading = false;
        state.errors = null;
      })
      .addCase(getParkingId.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
        state.parking = {};
      })

      .addCase(getParkingIdServices.pending, (state) => {
        state.successService = false;
        state.services = [];
        state.loading = true;
        state.errors = null;
      })
      .addCase(getParkingIdServices.fulfilled, (state, action) => {
        state.successService = true;
        state.services = action.payload.Services;
        state.loading = false;
        state.errors = null;
      })
      .addCase(getParkingIdServices.rejected, (state: any, action: any) => {
        state.successService = false;
        state.loading = false;
        state.errors = action.payload.Description;
        state.services = [];
      })
      .addCase(getParkingIdSusbcriptions.pending, (state) => {
        state.loadingSub = true;
        state.prepaidSubs = [];
        state.temporarySubs = [];

        state.errors = null;
      })
      .addCase(getParkingIdSusbcriptions.fulfilled, (state, action) => {
        state.loadingSub = false;
        state.prepaidSubs = action.payload.prepaidSubs;
        state.temporarySubs = action.payload.temporarySubs;

        state.errors = null;
      })
      .addCase(
        getParkingIdSusbcriptions.rejected,
        (state: any, action: any) => {
          state.loadingSub = false;
          state.loading = false;
          state.errors = action.payload.Description;
          state.subscriptionsParking = [];
        },
      )
      .addCase(getParkingIdLDReservations.pending, (state) => {
        state.loadingLDRes = true;
        state.ldResParking = [];

        state.errors = null;
      })
      .addCase(getParkingIdLDReservations.fulfilled, (state, action) => {
        state.ldResParking = action.payload.LDReservations;
        state.loadingLDRes = false;

        state.errors = null;
      })
      .addCase(
        getParkingIdLDReservations.rejected,
        (state: any, action: any) => {
          state.loadingLDRes = false;
          state.errors = action.payload.Description;
          state.ldResParking = [];
        },
      )

      .addCase(getParkingIdProximityParkings.pending, (state) => {
        state.proximityParkings = {};
        state.loading = true;
        state.errors = null;
      })
      .addCase(getParkingIdProximityParkings.fulfilled, (state, action) => {
        state.proximityParkings = action.payload.proximityParking;
        state.loading = false;
        state.errors = null;
      })
      .addCase(
        getParkingIdProximityParkings.rejected,
        (state: any, action: any) => {
          state.loading = false;
          state.errors = action.payload.Description;
          state.proximityParkings = {};
        },
      )

      // get current key account parkings
      .addCase(getPartnerParkings.pending, (state) => {
        state.loading = true;
        state.errors = null;
        state.description = null;
        state.parkings = [];
        state.success = false;
      })
      .addCase(getPartnerParkings.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.description = action.payload.Description;
        state.parkings = action.payload.Parkings;
        state.success = action.payload.Success;
      })
      .addCase(getPartnerParkings.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
        state.parkings = [];
        state.description = action.payload.Description;
        state.success = action.payload.Success;
      })
      // subscription list of the selected parking by the key account
      .addCase(getParkingSubscriptions.pending, (state) => {
        state.loading = true;
        state.errors = null;
        state.description = null;
        state.parkingSubscriptions = [];
        state.success = false;
      })
      .addCase(getParkingSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.errors = null;
        state.description = action.payload.Description;
        state.parkingSubscriptions = action.payload.ParkingSubscriptions;
        state.success = action.payload.Success;
      })
      .addCase(getParkingSubscriptions.rejected, (state: any, action: any) => {
        state.loading = false;
        state.errors = action.payload.Description;
        state.parkingSubscriptions = [];
        state.description = action.payload.Description;
        state.success = action.payload.Success;
      })
      .addCase(getParkingIdSusbcriptionsOrdered.pending, (state) => {
        state.loadingSub = true;
        state.prepaidSubs = [];
        state.temporarySubs = [];

        state.errors = null;
      })
      .addCase(getParkingIdSusbcriptionsOrdered.fulfilled, (state, action) => {
        state.loadingSub = false;
        state.prepaidSubs = action.payload.prepaidSubs;
        state.temporarySubs = action.payload.temporarySubs;

        state.errors = null;
      })
      .addCase(
        getParkingIdSusbcriptionsOrdered.rejected,
        (state: any, action: any) => {
          state.loadingSub = false;
          state.loading = false;
          state.errors = action.payload.Description;
          state.subscriptionsParking = [];
        },
      );
  },
});

export default parkingSlice.reducer;
